export default "__VITE_ASSET__DM5hrO0p__"